import { UpdateIdsAndRemittanceDataRow } from '@willow/types-iso';

import { makeValidator } from '../../shared/makeValidator';
import { getUpdateIdsAndRemittanceCrossFieldParser } from './UpdateIdsAndRemittanceCrossFieldParser';

export type ValidateUpdateIdsAndRemittanceOptions = {
  investorReportingEnabled: boolean;
};

export const validateUpdateIdsAndRemittanceData = (options?: Partial<ValidateUpdateIdsAndRemittanceOptions>) =>
  makeValidator({
    FieldParser: UpdateIdsAndRemittanceDataRow,
    CrossFieldParser: getUpdateIdsAndRemittanceCrossFieldParser(options),
  });
